import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "network_container" }
const _hoisted_2 = { class: "popTitle" }

import { ref } from 'vue';
import NetworkCard from './networkCard.vue';
import { NetworkChannelItem } from '@/view/withdraw/supportScript';

export default /*@__PURE__*/_defineComponent({
  __name: 'networkSelectPopup',
  props: {
    networkList: {}
  },
  emits: ['selectNetwork'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const emits = __emit
const show = ref(false);

const openPopup = () => {
    show.value = true;
}

const closePopup = () => {
    show.value = false;
}

const selectNetwork = (network: any) => {
    emits('selectNetwork', network)
}

__expose({
    openPopup,
    closePopup
})

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    "overlay-style": { overflow: 'hidden' },
    style: {
        minWidth: '100%',
        height: '70%',
        color: '#FFF',
    },
    class: "addressPopup"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('withdraw.chooseNetwork')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.networkList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(NetworkCard, {
              channel: item?.channel,
              channelName: item?.channelName,
              onClick: ($event: any) => (selectNetwork(item)),
              instructions: item?.instructions
            }, null, 8, ["channel", "channelName", "onClick", "instructions"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})